import axios from "axios";
import config from "../config/config";

// GET {serverUrl}/items/search  (serverUrl already ends with /api)
// Returns at most 10 items; the backend enforces the cap as well.
export async function searchItems(customerId, query, { signal } = {}) {
  const { data } = await axios.get(`${config.serverUrl}/items/search`, {
    params: { customer_id: customerId, q: query, limit: 10 },
    signal,
  });
  return Array.isArray(data?.items) ? data.items.slice(0, 10) : [];
}

// GET {serverUrl}/items/store -> store display name (null if not found)
export async function getStoreName(customerId, { signal } = {}) {
  const { data } = await axios.get(`${config.serverUrl}/items/store`, {
    params: { customer_id: customerId },
    signal,
  });
  return data?.name || null;
}

// GET {serverUrl}/items/favourites -> this store's favourite items
export async function getFavourites(customerId, { signal } = {}) {
  const { data } = await axios.get(`${config.serverUrl}/items/favourites`, {
    params: { customer_id: customerId },
    signal,
  });
  return Array.isArray(data?.items) ? data.items : [];
}

// GET {serverUrl}/items/menu-favourites -> items favourited on the AI Menu page
export async function getMenuFavourites(customerId, { signal } = {}) {
  const { data } = await axios.get(`${config.serverUrl}/items/menu-favourites`, {
    params: { customer_id: customerId },
    signal,
  });
  return Array.isArray(data?.items) ? data.items : [];
}

// GET {serverUrl}/items/browse -> the ordering page's default (no search) view:
//   { favourites: { inventory, ai_menu }, menu_sections: [...], categories: [...] }
export async function getBrowse(customerId, { signal } = {}) {
  const { data } = await axios.get(`${config.serverUrl}/items/browse`, {
    params: { customer_id: customerId },
    signal,
  });
  return {
    favourites: {
      inventory: Array.isArray(data?.favourites?.inventory) ? data.favourites.inventory : [],
      ai_menu: Array.isArray(data?.favourites?.ai_menu) ? data.favourites.ai_menu : [],
    },
    menuSections: Array.isArray(data?.menu_sections) ? data.menu_sections : [],
    categories: Array.isArray(data?.categories) ? data.categories : [],
  };
}

// GET {serverUrl}/items/category-items -> one "View More" page of a category
export async function getCategoryItems(customerId, category, offset, { signal } = {}) {
  const { data } = await axios.get(`${config.serverUrl}/items/category-items`, {
    params: { customer_id: customerId, category, offset },
    signal,
  });
  return { items: Array.isArray(data?.items) ? data.items : [], total: Number(data?.total) || 0 };
}

// GET {serverUrl}/items/all -> one page (10) of every item this store has
export async function getAllItems(customerId, offset = 0, { signal } = {}) {
  const { data } = await axios.get(`${config.serverUrl}/items/all`, {
    params: { customer_id: customerId, offset },
    signal,
  });
  return { items: Array.isArray(data?.items) ? data.items : [], total: Number(data?.total) || 0 };
}

// POST {serverUrl}/items/favourite -> mark / unmark one item for this store
export async function setFavourite(customerId, productId, isFavourite) {
  const { data } = await axios.post(`${config.serverUrl}/items/favourite`, {
    customer_id: customerId,
    product_id: productId,
    is_favourite: isFavourite,
  });
  return Boolean(data?.success);
}
